"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountServiceType = void 0;
var AccountServiceType;
(function (AccountServiceType) {
    AccountServiceType["twilio"] = "twilio";
    AccountServiceType["keen"] = "keen";
    AccountServiceType["S3"] = "S3";
    AccountServiceType["notify"] = "notify";
})(AccountServiceType || (exports.AccountServiceType = AccountServiceType = {}));
